import type { ToastOptions } from 'vue-toastification/dist/types/types';
import { useFormBuilderToast } from './useFormBuilderToast';

export const formBuilderCompactSuccessToastStyle: Partial<ToastOptions> = {
  toastClassName:
    '!box-border !h-[56px] !min-h-[56px] !max-h-[56px] !py-0 !px-0 !pr-3 !items-stretch',
  bodyClassName:
    '!flex !h-full !w-full !min-h-0 !min-w-0 !items-center !p-0 !leading-tight !text-sm',
  closeButton: false,
};

export function showFormElementDeleteSuccessToast(
  onUndo: () => void
) {
  const toast = useFormBuilderToast();

  toast.showSuccessToast(
    {
      title: 'Elemento deletado com sucesso.',
      type: 'success',
      onUndo,
      undoLabel: 'Desfazer',
    },
    formBuilderCompactSuccessToastStyle
  );
}
